import { SearchStepper } from "../search-stepper";
import { StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { UsBusinessSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/us-business-search-criteria/us-business-search-criteria.component";
import { UsBusinessSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/us-business-search-review/us-business-search-review.component";

export class UnitedStatesBusinessSearchStepper extends SearchStepper {
    constructor() {
        super()

        this.steps = [
            { title: "Search Criteria", content: UsBusinessSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: UsBusinessSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}